const INPUTTYPE = {
  U: 'input', // URL
  P: 'input',// 百分比
  c: 'input',// 币种
  ct: 'input', // 币种类型
  TAG: 'tag',// 标签
  Y: 'input',// 查找
  MR: 'input', // 查找多选
  LT: 'input',// 地理定位
  AD: 'input',// 地址
  H: 'input', // 电话
  E: 'input',// 电子邮件
  B: 'checkbox',// 复选框
  Z: 'input', // 公式
  R: 'input',// 记录类型
  enc: 'input',// 加密文本(存储加密)
  encd: 'input', // 加密文本(显示加密)
  C: 'input',// 累计汇总
  sum: 'input',// 累计汇总合计
  count: 'input', // 累计汇总记录数
  max: 'input',// 累计汇总最大
  min: 'input',// 累计汇总最小
  SCORE: 'input', // 评分
  D: 'date',// 日期
  F: 'datetime',// 日期/时间
  T: 'time', // 时间
  N: 'input',// 数字
  IMG: 'input',// 图片 -- Upload组件
  S: 'input',// 文本
  X: 'input',// 文本区
  A: 'kindeditor', // 文本区（富文本）-- wangEditor组件
  J: 'textarea',// 文本区（长）
  FL: 'file',
  L: 'select',// 选项列表
  Q: 'input', // 选项列表（多选）
  M: 'input',// 主详
  V: 'input'// 自动编号
}

export default INPUTTYPE